export const ethnicityOptions = [
    { value: "2135-2", label: "Hispanic or Latino/ Spanish" },
    { value: "2155-0", label: "Central American" },
    { value: "2182-4", label: "Cuban" },
    { value: "2184-0", label: "Dominican" },
    { value: "2137-8", label: "Spaniard" },
    { value: "2165-9", label: "South American" },
    { value: "2180-8", label: "Puerto Rican" },
    { value: "2148-5", label: "Mexican" },
    { value: "2178-2", label: "Latin American/Latin, Latino" },
    { value: "2186-5", label: "Not Hispanic / Latino" },
    { value: "declined", label: "Declined" },
];

export const raceOptions = [
    { value: "2106-3", label: "White" },
    { value: "1074-4", label: "Spanish American Indian" },
    { value: "2054-5", label: "Black / African American" },
    { value: "2058-6", label: "African American" },
    { value: "2028-9", label: "Asian" },
    { value: "1002-5", label: "American Indian or Alaskan Native" },
    { value: "2076-8", label: "Native Hawaiian or Pacific Islander" },
    { value: "2110-5", label: "English" },
    { value: "declined", label: "Declined" },
];

export const languageOptions = [
    { value: "eng", label: "English" },
    { value: "declined", label: "Declined" },
];

export const genderOptions = [
    { value: "F", label: "Female" },
    { value: "M", label: "Male" },
];

export const emergencyRelationshipOptions = [
    { value: "CHILD", label: "CHILD" },
    { value: "COUSIN", label: "COUSIN" },
    { value: "FRIEND", label: "FRIEND" },
    { value: "GUARDIAN", label: "GUARDIAN" },
    { value: "OTHER", label: "OTHER" },
    { value: "PARENT", label: "PARENT" },
    { value: "SIBLING", label: "SIBLING" },
    { value: "SPOUSE", label: "SPOUSE" },
];

export const maritalOptions = [
    { value: "S", label: "Single" },
    { value: "M", label: "Married" },
    { value: "D", label: "Divorced" },
    { value: "W", label: "Widowed" },
    { value: "X", label: "Separated" },
    { value: "P", label: "Partner" },
    { value: "U", label: "Unknown" },
];

export const rsiphysicians = [
    { value: "Dr. Gupta", label: "Dr. Gupta" },
    { value: "Dr. Tarantola", label: "Dr. Tarantola" },
    { value: "Dr. Ozkok", label: "Dr. Ozkok" },
    { value: "Dr. Myers", label: "Dr. Myers" },
    { value: "Dr. Allison", label: "Dr. Allison" },
    { value: "Dr. Khan", label: "Dr. Khan" },
    { value: "Dr. Peters", label: "Dr. Peters" },
    { value: "Dr. Pierce", label: "Dr. Pierce" },
    { value: "Dr. Shuler", label: "Dr. Shuler" },
    { value: "Dr. Barañano", label: "Dr. Barañano" }
];

export const rsisurgeonsOptions = [
    { value: "Dr. Gupta", label: "Dr. Gupta" },
    { value: "Dr. Tarantola", label: "Dr. Tarantola" },
    { value: "Dr. Ozkok", label: "Dr. Ozkok" },
    { value: "Dr. Myers", label: "Dr. Myers" },
    { value: "Dr. Allison", label: "Dr. Allison" }
];

export const rsiFullNamesurgeonsOptions = [
    { value: "Dr. Gupta", label: "Dr. Sunil Gupta" },
    { value: "Dr. Tarantola", label: "Dr. Ryan Tarantola" },
    { value: "Dr. Ozkok", label: "Dr. Ahmet Ozkok" },
    { value: "Dr. Myers", label: "Dr. John Myers" },
    { value: "Dr. Allison", label: "Dr. Sean Allison" }
];

export const segsurgeonsOptions = [
    { value: "Dr. Ates Hicks", label: "Dr. Ates Hicks" },
    { value: "Dr. McDaniel", label: "Dr. McDaniel" },
    { value: "Dr. Ray", label: "Dr. Ray" },
    { value: "Dr. Sugg", label: "Dr. Sugg" },
    { value: "Dr. Zloty", label: "Dr. Zloty" },
    { value: "Dr. St. John", label: "Dr. St. John" },
    { value: "Dr. Corder", label: "Dr. Corder" }
];

export const anesthesiaOptions = [
    { value: "general", label: "General" },
    { value: "mac", label: "MAC" },
    { value: "ivcs", label: "IVCS" },
    { value: "local", label: "Local" },
    { value: "block", label: "Block" },
];

export const seganesthesiaOptions = [
    { value: "topical", label: "Topical" },
    { value: "conscioussedation", label: "Conscious Sedation" },
    { value: "general-lma", label: "General (LMA)" },
    { value: "general - ettube", label: "General (ET - Tube)" },
    { value: "retrobulbar", label: "Retrobulbar" },
];


export const refractionsOptions = [
    { value: "true", label: "Yes, I do want a prescription for glasses and/or contacts." },
    { value: "false", label: "No, I do not want a prescription for glasses and/or contacts." }
];

export const imagingOptions = [
    { value: "Yes – I would like the Optos imaging performed today ($39.00).", label: "Yes – I would like the Optos imaging performed today ($39.00)." },
    { value: "No – I decline the Optos imaging and understand that using the Optomap greatly enhances my doctor's  ability to comprehensively examine my eyes. I understand that early detection of potentially threatening  disease is an important part of my thorough eye health evaluation. I consent to have my pupils dilated today.", label: "No – I decline the Optos imaging and understand that using the Optomap greatly enhances my dcotor's  ability to comprehensively examine my eyes. I understand that early detection of potentially threatening  disease is an important part of my thorough eye health evaluation. I consent to have my pupils dilated today." },
    { value: "I have read and understand the information and elect to refuse both dilation and Optos imaging against my doctor's recommendation.", label: "I have read and understand the information and elect to refuse both dilation and Optos imaging against my doctor's recommendation." }
];

export const payOptions = [
    { value: "You have no health insurance", label: "You have no health insurance" },
    { value: "You have health insurance, but you do NOT want your insurance billed and instead want to pay out of pocket", label: "You have health insurance, but you do NOT want your insurance billed and instead want to pay out of pocket" },
];

export const eyesOptions = [
    { value: "RIGHT", label: "RIGHT" },
    { value: "LEFT", label: "LEFT" },
    { value: "BILATERAL", label: "BILATERAL" },
    { value: "NO LATERALITY", label: "NO LATERALITY" },
];


